export type AvsErrorResponse = {
  errors: string[];
};

const errorPrefix = '\u{25CF} ';

export namespace AvsErrorResponse {
  /** Create an @see Error to throw from the provided @see AvsErrorResponse. */
  export function createError(
    message: string | null,
    avsError: AvsErrorResponse
  ): Error {
    const errorList = errorPrefix + avsError.errors.join(`\n${errorPrefix}`);
    return new Error(
      (message) ? `${message}\n${errorList}` : errorList
    );
  }

  /** Check if @see value is an @see AvsErrorResponse. */
  export function is(value: unknown): value is AvsErrorResponse {
    return (
      !!value
      && typeof value === 'object'
      && 'errors' in value
      && value.errors instanceof Array
    );
  }
}
